const ChevronRightIcon = ({
  className = ""
}: {
  className?: string;
}) => {
  return <svg strokeWidth='0' viewBox='0 0 16 16' height='20px' width='20px' fill='currentcolor' stroke='currentcolor' focusable={false} className={className} aria-hidden='true' data-sentry-element="svg" data-sentry-component="ChevronRightIcon" data-sentry-source-file="ChevronRightIcon.tsx">
      <path fillRule='evenodd' d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z' data-sentry-element="path" data-sentry-source-file="ChevronRightIcon.tsx"></path>
    </svg>;
};
export default ChevronRightIcon;